/* eslint-disable @stripe-internal/stripe/no-mixed-react-exports */
import {PropsWithChildren, useMemo, useContext, createContext} from 'react';
import {DEFAULT_PREFIX, useGlobalizationPair} from 'mkt-ssr/lib/globalization';
import {LinkResolver} from 'mkt-ssr/lib/routing/LinkResolver/LinkResolver';
import {STRIPE_ENV, useStripeEnv} from 'mkt-ssr/lib/env';
import {useContentfulConfig} from 'mkt-ssr/lib/contentful/config';

const LinkResolverContext = createContext(
  new LinkResolver({
    resolvedHost: 'stripe.com',
    actualHost: 'stripe.com',
    currentGlobalization: DEFAULT_PREFIX,
    stripeEnv: STRIPE_ENV.PROD,
    contentfulConfig: {
      isPreview: false,
      environment: '',
      spaceId: '',
    },
  }),
);

export function useLinkResolver() {
  return useContext(LinkResolverContext);
}

export function LinkResolverProvider({
  resolvedHost,
  actualHost,
  children,
}: PropsWithChildren<{resolvedHost: string; actualHost: string}>) {
  const currentGlobalization = useGlobalizationPair();
  const stripeEnv = useStripeEnv();
  const contentfulConfig = useContentfulConfig();
  const linkResolver = useMemo(
    () =>
      new LinkResolver({
        resolvedHost,
        actualHost,
        currentGlobalization,
        stripeEnv,
        contentfulConfig,
      }),
    [
      resolvedHost,
      actualHost,
      stripeEnv,
      currentGlobalization,
      contentfulConfig,
    ],
  );

  return (
    <LinkResolverContext.Provider value={linkResolver}>
      {children}
    </LinkResolverContext.Provider>
  );
}
